import ReportDom from "../../../../components/common/ReportDom";
import ManufacturingVoucherBody from "./ManufacturingVoucherBody";

export default function ManufacturingPrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <ManufacturingVoucherBody mf_id={id} printMode />}
    />
  );
}
